import { MatPaginatorIntl } from '@angular/material/paginator';

export function getCustomPaginatorIntl(itemsPerPageLabel: string) {
    const customPaginatorIntl = new MatPaginatorIntl();
    customPaginatorIntl.itemsPerPageLabel = itemsPerPageLabel;
    return customPaginatorIntl;
}
